import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getUnlinkedTrackers = async (customerId) => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}trackers/unlinked/list/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          customer_id: customerId,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch unlinked trackers:", error);
    throw error;
  }
};

export { getUnlinkedTrackers };
